/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import fetchData from '../fetch/index.tsx';
import type { State, Props } from '../fetch/types.tsx';

const fetchIssueCreate = (): Action<State, Props> => fetchData('issue-create');

export default fetchIssueCreate;
